const imageSvgList = ['bmp', 'gif', 'jpeg', 'jpg', 'png', 'tif', 'tiff', 'svg']
const audioSvgList = ['aac', 'flac', 'm4a', 'mp3', 'oga', 'wav', 'wma']
const videoSvgList = [
  '3gp',
  '3gpp',
  '3gpp2',
  'asf',
  'avi',
  'dv',
  'm2t',
  'm4v',
  'mkv',
  'mov',
  'mp4',
  'mpeg',
  'mpg',
  'mts',
  'oggtheora',
  'ogv',
  'rm',
  'ts',
  'vob',
  'webm',
  'wmv',
  'flv',
]
const documentSvgList = [
  'doc',
  'docs',
  'ppt',
  'pptx',
  'pptm',
  'pps',
  'ppsm',
  'ppsx',
  'xls',
  'xlsx',
  'txt',
]
const apkSvgList = ['apk']

export { imageSvgList, apkSvgList, videoSvgList, documentSvgList, audioSvgList }
